"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vaglia": {
    "782111ac": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "carlone": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63a50325": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto-maggio": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ab7fd965": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "montesenario": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a34832f0": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "olmo": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2c08b99": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "pescina": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de3878f6": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "san-jacopo": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6204b1c": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele-alle-macchie": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38fd9a34": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "skipSearch": false
    }],
    "starniano": [{
      "hkey": "a5a519d2",
      "slug": "vaglia",
      "name": "Vaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "965fecce": [{
      "hkey": "190ec18c",
      "slug": "pratolino",
      "name": "Pratolino",
      "primary": true,
      "skipSearch": false
    }],
    "uccellatoio": [{
      "hkey": "190ec18c",
      "slug": "pratolino",
      "name": "Pratolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vaglia"
    }]
  }
};
exports["default"] = _default;